import { NgModule } from '@angular/core';
import { OrderBy } from '../pipes/orderBy.pipes';
import { DataFilterPipe } from '../pipes/filter.pipes';
import { RoundPipe } from '../pipes/rounded.pipes';

@NgModule({
  declarations: [OrderBy,DataFilterPipe, RoundPipe],
  exports: [OrderBy,DataFilterPipe, RoundPipe]
})
export class PipesModule { }


// WEBPACK FOOTER //
// ./src/app/modules/pipes.module.ts